module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    staticClass: "icon__img",
    attrs: {
      "width": "101",
      "height": "113",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M0 36.457h99.61c-.301-11.218-3.119-19.558-8.452-25.021C85.824 5.973 76.45 2.16 63.035 0c-2.663 7.624-7.21 11.436-13.639 11.436-6.429 0-10.711-3.812-12.846-11.436C22.978 2.386 13.66 6.197 8.593 11.436 4.18 15.997 1.316 24.338 0 36.456z",
      "id": "a"
    }
  }), _c('path', {
    attrs: {
      "d": "M.357.696c-1.32 1.187 1.056 6.558 6.488 6.101 5.432-.456 6.493-4.13 6.176-4.893-.16-.381-2.905-.853-5.875-1.208C4.193.343 1.016.104.357.696z",
      "id": "c"
    }
  })]), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M29.955 79.36c-.55-.216-6.527-4.58-7.886-10.429-1.377-5.926 1.865-13.347 1.411-14.57-.9-2.432-9.912-25.043 3.648-42.587.383-.497 1.26-1.507 2.084-1.862.926-.398 1.855-.18 3.317-1.622C37.717 3.173 44.406.352 50 .19c9.162-.267 18.734 1.217 26.339 12.25 6.78 9.84 5.06 29.581 4.801 30.333-.271.791 6.446 7.842 8.09 17.461.985 5.761.46 10.947-1.9 16.75-1.195 2.94.732 4.52-.604 5.927-.88.927-25.497 8.457-31.536 8.136-6.039-.32-24.129-11.25-25.235-11.686z",
      "fill": "#280A0C"
    }
  }), _c('path', {
    attrs: {
      "d": "M37.003 76.724c0 .933-8.226 6.764 1.856 10.741 10.083 3.978 21.532 3.544 23.256 2.058 1.723-1.486 6.359-9.648 3.783-10.83-1.26-.578-3.853-2.303-5.24-4.805-1.45-2.612-1.949-5.077-1.105-6.08.844-1.004 4.688-2.52 7.753-7.659 3.066-5.138 2.58-8.412 2.839-8.72.13-.155 1.196.337 2.754-.255 1.706-.648 3.745-2.683 4.457-4.463.478-1.194 1.13-3.068 1.13-4.871 0-2.385-2.036-4.096-3.692-4.096-2.057 0-2.45 2.383-2.288 3.158.161.775-.363 2.263-.7 2.08-.41-.222-.523-2.99-2.342-5.576-2.388-3.393-3.3-3.805-6.783-5.061-4.239 0-12.582-.612-16.872-2.072-6.29-2.14-6.777-9.004-8.586-9.004-1.619 0-.734 2.61-2.569 6.2-1.026 2.007-3.12 4.066-4.254 6.132-1.712 3.12-2.477 6.153-2.656 6.153-.511 0-1.023-1.665-2.177-1.665-2.264 0-5.367 2.79-4.158 6.457.918 2.783 3.232 7.058 8.032 6.883.281.216.331 4.439 3.267 8.69 2.332 3.38 3.928 4.812 7.533 7.085 1.514.955.209 4.205-.982 6.98-1.139 2.652-2.256 2.315-2.256 2.54z",
      "fill": "#EE9985"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.553 67.807c.844-1.003 4.688-2.519 7.753-7.658 3.066-5.138 2.58-8.412 2.839-8.72.13-.155 1.196.337 2.754-.255 1.706-.648 3.745-2.683 4.457-4.463.478-1.194 1.13-3.068 1.13-4.871 0-2.385-2.036-4.096-3.692-4.096-2.057 0-2.45 2.383-2.288 3.158.161.775-.363 2.263-.7 2.08-.41-.222-.523-2.99-2.342-5.576-2.388-3.393-3.3-3.805-6.783-5.061-4.239 0-12.582-.612-16.872-2.072-6.29-2.14-6.777-9.004-8.586-9.004-1.619 0-.734 2.61-2.569 6.2-1.026 2.007-3.12 4.066-4.254 6.132-1.712 3.12-2.477 6.153-2.656 6.153-.511 0-1.023-1.665-2.177-1.665-2.264 0-5.367 2.79-4.158 6.457.918 2.783 3.232 7.058 8.032 6.883.281.216.331 4.439 3.267 8.69 2.332 3.38 3.928 4.812 7.533 7.085.772.487 5.392 2.092 10.01 2.242 4.439.144 8.888-1.147 9.302-1.639z",
      "fill": "#F6A78E"
    }
  }), _c('path', {
    attrs: {
      "d": "M61.864 62.043c2.35-4.208 2.14-12.671.238-18.108-1.38-3.949-4.19-5.257-5.583-6.386-3.31-2.685-6.847-3.961-11.137-5.42-2.432-.829-5.283-2.75-6.314-4.66-1.634-3.03-.736-6.2-1.845-6.2-1.619 0-.734 2.61-2.569 6.2-1.026 2.007-3.12 4.066-4.254 6.132-1.712 3.12-2.477 6.153-2.656 6.153-.511 0-1.023-1.665-2.177-1.665-2.264 0-5.367 2.79-4.158 6.457.918 2.783 3.232 7.058 8.032 6.883.281.216.331 4.439 3.267 8.69 2.332 3.38 3.928 4.812 7.533 7.085 9.419 3.841 18.698.074 21.623-5.16z",
      "fill": "#FEBCA5"
    }
  }), _c('path', {
    attrs: {
      "d": "M37.003 76.724c0 .933-8.226 6.764 1.856 10.741 10.083 3.978 21.532 3.544 23.256 2.058 1.723-1.486 6.359-9.648 3.783-10.83-.971-.446-2.734-1.572-4.127-3.211-.414-.488-4.874.921-11.52 0-6.647-.921-9.512-5.228-9.812-4.309-.32.98-.758 2.026-1.18 3.01-1.139 2.653-2.256 2.316-2.256 2.54z",
      "fill": "#FBB39E"
    }
  }), _c('g', {
    attrs: {
      "transform": "translate(.104 75.061)"
    }
  }, [_c('mask', {
    attrs: {
      "id": "b",
      "fill": "#fff"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#8741BA",
      "xlink:href": "#a"
    }
  }), _c('path', {
    attrs: {
      "d": "M65.354 36.457h34.255c-.3-11.218-3.118-19.558-8.451-25.021C85.824 5.973 76.45 2.16 63.035 0c-.67 1.727-1.204 2.962-1.599 3.705C67.648 6.537 77.384 14.45 74.05 19.237c-5.095 7.315-7.993 13.055-8.695 17.22zM17.646 22.814c-1.071 0-3.248 4.548-6.53 13.643h9.848c-1.07-9.095-2.176-13.643-3.318-13.643z",
      "fill": "#7636AC",
      "mask": "url(#b)"
    }
  })]), _c('g', {
    attrs: {
      "transform": "translate(43.655 55.949)"
    }
  }, [_c('mask', {
    attrs: {
      "id": "d",
      "fill": "#fff"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#c"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#DA4058",
      "opacity": ".662",
      "xlink:href": "#c"
    }
  }), _c('path', {
    attrs: {
      "d": "M.911-.378c-.505 1.845 1.618 2.1 5.246 2.471s7.082.691 7.082-.444S1.416-2.223.911-.378z",
      "fill": "#FFF",
      "mask": "url(#d)"
    }
  }), _c('path', {
    attrs: {
      "d": "M.296 5.86c.54-.34 3.29-2.43 6.148-2.081 2.858.349 4.142 2.222 4.833 2.515.46.195-1.47.892-5.79 2.091C1.667 6.93-.063 6.088.297 5.861z",
      "fill": "#F8677F",
      "mask": "url(#d)"
    }
  })]), _c('path', {
    attrs: {
      "d": "M24.086 41c.342.407.94.268 1.243.407.177.08.767.37.85 1.61.082 1.24.115 1.325-.186 1.786-.168.257-.532.12-.664.39-.263.539-.226 1.306 0 1.42.542.27 2.329-1.33 1.923-3.816-.405-2.486-3.888-2.655-3.166-1.797z",
      "fill": "#F1A18C"
    }
  }), _c('path', {
    attrs: {
      "d": "M76.214 41c-.343.407-1.156.624-1.459.762-.177.081-.994.092-1.076 1.332-.082 1.24-.355 1.6 0 1.954.29.29.898-.075 1.076.29.165.337-.295 1.251-.404 1.305-.541.27-2.306-1.37-1.901-3.856.405-2.486 4.485-2.645 3.764-1.787z",
      "fill": "#F19F8A"
    }
  }), _c('path', {
    attrs: {
      "d": "M50.5 43.178c.307 0 .723 1.61.885 3.156.09.863 1.436 2.515 2.754 4.759.739 1.257-2.756 3.63-2.996 3.403-.239-.227.947-1.726 1.088-2.496.17-.928-1.155-3.369-1.576-4.803-.484-1.648-.357-4.019-.155-4.019z",
      "fill": "#EF9E89"
    }
  }), _c('g', {
    attrs: {
      "transform": "translate(39 41)",
      "fill": "#000"
    }
  }, [_c('ellipse', {
    attrs: {
      "cx": "2",
      "cy": "2.5",
      "rx": "2",
      "ry": "2.5"
    }
  }), _c('ellipse', {
    attrs: {
      "cx": "21",
      "cy": "2.5",
      "rx": "2",
      "ry": "2.5"
    }
  })]), _c('g', {
    attrs: {
      "fill": "#000"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35.123 40.084c-.808-.451 5.56-5.127 8.374-4.502.772.17 2.244 1.59.526 1.59-1.665 0-3.18.224-4.423.648-2.002.683-4.007 2.527-4.477 2.264zM64.831 40.337c.877-.452-5.584-5.856-8.64-5.231-.837.17-2.118 1.534-.434 1.681 2.243.197 3.61.594 4.816 1.136 1.952.877 3.748 2.677 4.258 2.414z"
    }
  })]), _c('g', {
    attrs: {
      "transform": "translate(27 33)",
      "stroke": "#8C46B8"
    }
  }, [_c('circle', {
    attrs: {
      "stroke-width": "1.8",
      "fill-opacity": ".502",
      "fill": "#FFF",
      "cx": "9.5",
      "cy": "9.5",
      "r": "9.5"
    }
  }), _c('circle', {
    attrs: {
      "stroke-width": "1.8",
      "fill-opacity": ".502",
      "fill": "#FFF",
      "cx": "35.5",
      "cy": "9.5",
      "r": "9.5"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "d": "M19 9.5h6.5"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eb8a13f","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/icon/MentoringIcon.vue
// module id = c726dfa9dc06292cbfb7
// module chunks = 89